import React from "react";
import Divider from "@mui/material/Divider";
import BarGraph from "../Graph/ApexBarGraph";
import Piechart from "../Graph/ApexPieChart";
import Top3LocationPieChart from "../Graph/ApexPieChartTop3Location";
import Top3AlertPieChart from "../Graph/ApexPieChartTop3Alert";
import ApexBarGraphForAlertType from "../Graph/ApexBarGraphForAlertType";
import { BsFileEarmarkBarGraph } from "react-icons/bs";
import { FiPieChart } from "react-icons/fi";
import "./index.css";
import DashboardFilterDropDown from "./DashboardFilterDropDown";

function Main() {
  return (
    <div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-2">
        <div className="bg-white rounded-xl p-3 border border-gray-400">
          <div className="flex items-center mb-2">
            <FiPieChart size={30} className="text-teal-600" />
            <h6 className="ml-3 text-md font-medium text-teal-700">
              Top 3 Locations in the Past Month
            </h6>
          </div>
          <Divider />
          <Top3LocationPieChart />
        </div>

        <div className="bg-white rounded-xl p-3 border border-gray-400">
          <div className="flex items-center mb-2">
            <FiPieChart size={30} className="text-teal-600" />
            <h6 className="ml-3 text-md font-medium text-teal-700">
              Top 3 Alerts in the Past Month
            </h6>
          </div>
          <Divider />
          <Top3AlertPieChart />
        </div>
      </div>

      <div className="flex justify-end mb-0 w-full">
        <DashboardFilterDropDown />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-white rounded-xl p-3 border border-gray-400">
          <div className="flex items-center mb-2">
            <BsFileEarmarkBarGraph size={30} className="text-teal-600" />
            <h6 className="ml-3 text-md font-medium text-teal-700">
              Alerts Bar Graph For Alert Type - Filtered View
            </h6>
          </div>
          <Divider />
          <ApexBarGraphForAlertType />
        </div>

        <div className="bg-white rounded-xl p-3 border border-gray-400">
          <div className="flex items-center mb-2">
            <FiPieChart size={30} className="text-teal-600" />
            <h6 className="ml-3 text-md font-medium text-teal-700">
              Alerts Pie Graph - Filtered View
            </h6>
          </div>
          <Divider />
          <Piechart />
        </div>
      </div>
      <div className="mt-4">
        <div className="bg-white rounded-xl p-3 border border-gray-400">
          <div className="flex items-center mb-2">
            <BsFileEarmarkBarGraph size={30} className="text-teal-600" />
            <h6 className="ml-3 text-md font-medium text-teal-700">
              Alerts Bar Graph - Filtered View
            </h6>
          </div>
          <Divider />
          <BarGraph />
        </div>
      </div>
    </div>
  );
}

export default Main;
